export enum WindowSizeEnum {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
}
